import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PROFILE_LOADING = 'GET_PROFILE_LOADING';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_REJECT = 'GET_PROFILE_REJECT';

//* ACTIONS ------------------------------------------------
export const getProfileLoading = () => ({ type: GET_PROFILE_LOADING });
export const getProfileSuccess = (payload) => ({ type: GET_PROFILE_SUCCESS, payload });
export const getProfileReject = (payload) => ({ type: GET_PROFILE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getProfileRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Profiles/web/GetProfiles`, options);
};

